var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('b-link',{attrs:{"href":"http://www.graudissenydigitalitec.udl.cat/"}},[_vm._v("Grado Diseño Digital y Tecnologías Creativas")]),_vm._v(" || "),_c('b-link',{attrs:{"href":"http://www.udl.cat/"}},[_vm._v("Universitat de Lleida")]),_vm._v(". ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }